export const JST_TIME_ZONE = "Asia/Tokyo";

function getJstDateParts(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: JST_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);

  const getPart = (type) => parts.find((part) => part.type === type)?.value || "00";

  return {
    year: getPart("year"),
    month: getPart("month"),
    day: getPart("day"),
  };
}

export function getJstTodayInputValue(date = new Date()) {
  const { year, month, day } = getJstDateParts(date);
  return `${year}-${month}-${day}`;
}

export function getJstCurrentMonthInputValue(date = new Date()) {
  return getJstTodayInputValue(date).slice(0, 7);
}

export function createLocalDateFromInputValue(value) {
  const [year, month, day] = String(value).slice(0, 10).split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function getDaysInMonthFromInputValue(value) {
  const [year, month] = String(value).slice(0, 7).split("-").map(Number);
  return new Date(year, month, 0).getDate();
}

export function formatInputDateToJapanese(value) {
  const [year, month, day] = String(value).slice(0, 10).split("-").map(Number);
  if (!year || !month || !day) {
    return value;
  }
  return `${year}年${month}月${day}日`;
}

